import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "h6 tablet:h4" }
const _hoisted_3 = { class: "pr-40 text-16 tablet:max-w-[55ch]" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mb-24 w-full text-14 tablet:mb-32" }
const _hoisted_6 = { class: "pb-12 text-center" }
const _hoisted_7 = { class: "flex justify-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_store_picker = _resolveComponent("store-picker")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString($data.locale.title), 1),
      _createElementVNode("button", {
        type: "button",
        class: "mr-8",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleModal && $options.toggleModal(...args)))
      }, [
        _createVNode(_component_v_icon, {
          icon: "close",
          width: 17,
          height: 17,
          "width-mobile": 14,
          "height-mobile": 14
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        innerHTML: $data.locale.greetings
      }, null, 8, _hoisted_4),
      _createTextVNode(" " + _toDisplayString(`${$data.geo.countryName}. ${$data.locale.shipping_to} ${$data.geo.countryName} ${$data.locale.only_from} ${$data.proposedShop?.host}`), 1)
    ]),
    _createElementVNode("a", {
      href: "#",
      class: "btn-primary btn-small tablet:btn-medium tablet:btn-large my-24 text-center tablet:my-32",
      onClick: _cache[1] || (_cache[1] = $event => ($options.redirectToSuggested()))
    }, _toDisplayString($data.locale.go_to) + " " + _toDisplayString($data.proposedShop?.host), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "btn-accent m-auto block text-16 font-medium tablet:text-22",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.toggleModalState && $options.toggleModalState(...args)), ["prevent"]))
      }, _toDisplayString($data.locale.stay_on) + " " + _toDisplayString($data.location.replace('www.', '')), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString($data.locale.select_region), 1),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_store_picker)
    ])
  ]))
}